import { render, staticRenderFns } from "./templateManagement.vue?vue&type=template&id=c8903d0a&scoped=true"
import script from "./templateManagement.vue?vue&type=script&lang=js"
export * from "./templateManagement.vue?vue&type=script&lang=js"
import style0 from "./templateManagement.vue?vue&type=style&index=0&id=c8903d0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8903d0a",
  null
  
)

export default component.exports